import { useEffect, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { decryptData } from "../../../utils/encrypt";
import _ from "underscore";
import { dateConvert } from "../../../utils/Helper";

export const useBlockingSession = ({ projectChanged }) => {


    const [rowData, setRowData] = useState([]);
    const [loader, setLoader] = useState(false)
    const blockingSessionsCols = [
        {
            key: "session_id",
            label: "Session Id",
            headerStyle: { textAlign: "center" },
            style: { width: "5%", textAlign: "center" },

        },
        {
            key: "blocking_session_id",
            label: "Session Blocking Id",
            headerStyle: { textAlign: "center" },
            style: { width: "10%", textAlign: "center" },
        },
        {
            key: "status",
            label: "Status",
            headerStyle: { textAlign: "center" },
            style: { width: "15%", textAlign: "center" },
        },
        {
            key: "wait_type",
            label: "Wait Type",
            style: { width: "15%" },
        },
        {
            key: "wait_resource",
            label: "Wait Resource",
            style: { width: "25%" },
        },
        {
            key: "wait_time_ms",
            label: "Wait Time ms",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
            render: (row) => <span>{row?.wait_time_ms?.toLocaleString() || 0}</span>
        },
        {
            key: "cpu_time_ms",
            label: "cpu_time_ms",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
        },

        {
            key: "elapsed_time_ms",
            label: "Elapsed Time ms",
            headerStyle: { textAlign: "center" },
            style: { textAlign: "center", width: "10%" },
        },
    ];

    useEffect(() => {
        getBlockingSession()
    }, [projectChanged])

    useEffect(() => {
        const interval = setInterval(() => {
            getBlockingSession();
        }, 120000);

        return () => clearInterval(interval);
    }, []);

    const getBlockingSession = async () => {
        try {
            const selectedProject = sessionStorage.getItem("inspectra_project") ? JSON.parse(decryptData(sessionStorage.getItem("inspectra_project"))) : {};
            if (!_.isEmpty(selectedProject)) {
                setLoader(true)
                const payload = {
                    "project_id": selectedProject?.project_id
                }
                const response = await services.getInvokeRemote("POST", Urls("GETBLOCKINGSESSIONS"), payload);
                if (response?.body?.data?.blocking_sessions) {
                    setRowData(response?.body?.data?.blocking_sessions)
                } else {
                    setRowData([])
                }
                setLoader(false)
            }

        } catch (error) {
             setLoader(false)
            console.error("error::", error)
        }
    }

    return {
        blockingSessionsCols,
        rowData,
        loader
    }
}